import React from "react";
import Modal from "react-bootstrap/Modal";
import "./SuccessModal.css";
import { useNavigate } from "react-router-dom";
const SuccessModal = ({ show, onClose }) => {
  const navigate = useNavigate();
  const handleNavigateToProfile = () => {
    navigate("/user-profile/profile");
  };
  return (
    <Modal centered show={show} onHide={onClose} size="md">
      <Modal.Header closeButton>
        <Modal.Title>Success</Modal.Title>
      </Modal.Header>
      <Modal.Body className="care-suceess-modal">
        <img src={require("../Animations/succes-gifi.gif")} alt="Success" />
        <h3 className="step-title">Profile Completed</h3>
        <p>
          Congratulations! you’ve successfully completed your professional
          profile setup. You’ve earned a total of <strong>15 XP</strong>.
        </p>
        <div className="data-column">
          <button type="button" onClick={handleNavigateToProfile}>
            View Profile
          </button>
          <button type="button">Book Online Training Slot</button>
          <button type="button">Refer & Earn Bonus XP</button>
          <button type="button">Download e-ID Badge (Optional)</button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default SuccessModal;
